import React, { useState } from "react";
import { FacebookLogo, WhatsappLogo, XLogo, LinkSimple, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * One-tap social share bar for a job/article.
 * - WhatsApp & X get the custom pre-filled message + link.
 * - Facebook only accepts the URL (it strips post text and pulls the branded
 *   card from the page's OG tags — a Facebook platform limitation).
 */
export const ShareButtons = ({ url, message, copyLabel = "Copy link", copiedLabel = "Copied!" }) => {
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;
  const text = message || "";

  const open = (href) =>
    window.open(href, "_blank", "noopener,noreferrer,width=640,height=640");

  const shareFacebook = () => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`);
  const shareWhatsApp = () => open(`https://wa.me/?text=${enc(`${text} ${url}`.trim())}`);
  const shareX = () => open(`https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}`);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = url; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        document.execCommand("copy"); document.body.removeChild(ta);
      } catch { window.prompt("Copy this link:", url); return; }
    }
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 2000);
  };

  const btnCls = "group inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-semibold text-zinc-200 transition-all hover:border-white/20 hover:bg-white/10 active:scale-95";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <button onClick={shareWhatsApp} data-testid="share-whatsapp" className={btnCls}>
        <WhatsappLogo size={18} weight="fill" style={{ color: "#25D366" }} /><span>WhatsApp</span>
      </button>
      <button onClick={shareFacebook} data-testid="share-facebook" className={btnCls}>
        <FacebookLogo size={18} weight="fill" style={{ color: "#1877F2" }} /><span>Facebook</span>
      </button>
      <button onClick={shareX} data-testid="share-x" className={btnCls}>
        <XLogo size={18} weight="fill" style={{ color: "#e7e7e7" }} /><span>X</span>
      </button>
      <button onClick={copy} data-testid="share-copy" className={btnCls}>
        {copied
          ? <Check size={18} weight="fill" style={{ color: "#22c55e" }} />
          : <LinkSimple size={18} weight="fill" style={{ color: "#FF7A1A" }} />}
        <span>{copied ? copiedLabel : copyLabel}</span>
      </button>
    </div>
  );
};
